module.exports = __webpack_public_path__ + "e06df4b0cde64bbe423afe551c1a86de.jpg";